import React, { useEffect } from "react";
import { Footer } from "../components/Footer";
import { MobileAssessmentBar } from "../components/MobileAssessmentBar";
import { Navigation } from "../components/Navigation";
import { TypographyMarquee } from "../components/TypographyMarquee";
import { VideoIntro } from "../components/VideoIntro";
import { AssessmentSection } from "../components/home/AssessmentSection";
import { CoachingSection } from "../components/home/CoachingSection";
import { FaqSection } from "../components/home/FaqSection";
import { FinalCtaSection } from "../components/home/FinalCtaSection";
import { HelpSection } from "../components/home/HelpSection";
import { HeroSection } from "../components/home/HeroSection";
import { MethodSection } from "../components/home/MethodSection";
import { PhilosophySection } from "../components/home/PhilosophySection";
import { StorySection } from "../components/home/StorySection";
import { siteLinks } from "../data/site";
export function HomePage() {
  useEffect(() => {
    document.title = "Leo Tovar Method | Movement Assessment & Performance Coaching";
    const description = "Understand how you move with a professional movement assessment from Leo Tovar. Online worldwide and 1:1 coaching in Denver.";
    let meta = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    if (!meta) {
      meta = document.createElement("meta");
      meta.name = "description";
      document.head.appendChild(meta);
    }
    meta.content = description;
  }, []);
  return <div className="min-h-screen w-full bg-cream text-ink" data-id="element-265" data-mp="1vquemlh95uak">
      <VideoIntro data-id="element-266" data-mp="1vtfg39dn287s" />
      <Navigation assessmentUrl={siteLinks.assessment} data-id="element-267" data-mp="20qyuc9ac6kzq" />
      <main data-id="element-268" data-mp="20pe1qp7l1c4i">
        <HeroSection assessmentUrl={siteLinks.assessment} data-id="element-269" data-mp="20t1vnpgxw0jr" />
        <TypographyMarquee data-id="element-270" data-mp="25ql94n5tc9an" />
        <PhilosophySection data-id="element-271" data-mp="25npa0vi8bekm" />
        <MethodSection data-id="element-272" data-mp="3c64bujf4mo3e" />
        <HelpSection data-id="element-273" data-mp="3c6nhp1ri5m12" />
        <AssessmentSection assessmentUrl={siteLinks.assessment} data-id="element-274" data-mp="3c5cfv7hmaocl" />
        <CoachingSection data-id="element-275" data-mp="3h4fiyme1ekhx" />
        <TypographyMarquee reverse data-id="element-276" data-mp="3h3nmzagj2kr4" />
        <StorySection data-id="element-277" data-mp="3h6s2v53cv4xm" />
        <FaqSection data-id="element-278" data-mp="2rgjp509wup41" />
        <FinalCtaSection assessmentUrl={siteLinks.assessment} data-id="element-279" data-mp="2rfs24dudpzpd" />
      </main>
      <Footer data-id="element-280" data-mp="2mhyt7d1oyrle" />
      <MobileAssessmentBar href={siteLinks.assessment} data-id="element-281" data-mp="2mii2k5da07nt" />
    </div>;
}